import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import CompanyHero from './CompanyHero';
import WhoWereBuiltForSection from './WhoWereBuiltForSection';
import SeenProblemUpCloseSection from './SeenProblemUpCloseSection';
import AuditReadySection from './AuditReadySection';
import RealOperationsSection from './RealOperationsSection';

const CompanyPage = () => {
    return (
        <>
            <Header />
            <CompanyHero />
            <WhoWereBuiltForSection />
            <SeenProblemUpCloseSection />
            <AuditReadySection />
            <RealOperationsSection />
            <Footer />
        </>
    );
};

export default CompanyPage;
